export default {
    'peppu-market': {
        // 'key': 'value',
    },
};